import SearchApiIndex from './all-space-index';

export default class SearchApiAccount {
  private static instance: SearchApiAccount | undefined;

  public static init = () => {
    SearchApiAccount.instance = new SearchApiAccount();
  };

  public static hasInitialized = () => !!SearchApiAccount.instance;

  public static getInstance = (): SearchApiAccount => {
    if (!SearchApiAccount.instance) {
      throw new Error('SearchApi not initialized.');
    }
    return SearchApiAccount.instance;
  };

  public static clear = () => (SearchApiAccount.instance = undefined);

  public readonly indices = {
    allSpace: (): SearchApiIndex => new SearchApiIndex()
  };
}
